<template>
   
    <div> 
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 权限管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>渠道权限</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <div class="container"> 
            <div class="handle-box" style="overflow-y:hidden; margin-top:-10px;" v-loading="loading"  element-loading-text="正在查询..." element-loading-spinner="el-icon-loading"> 
            <span :hidden="closeSearch"> 
                 
                <el-input v-model.trim="query.realName" style="width:100px" placeholder="真实姓名" class="handle-input mr10"></el-input>  
                <el-input v-model.trim="query.id" style="width:100px;" placeholder="代理ID" class="handle-input mr10"></el-input> 
                <el-select v-model="query.rcode"  placeholder="角色" filterable  clearable   style="width:100px;margin-right:10px;" @clear="resetSelect" class="handle-select mr10">
                   <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                </el-select>  
                <el-input v-model.trim="query.shopCode" style="width:120px" placeholder="店铺编码" class="handle-input mr10"></el-input> 
                 
                <el-input v-model.trim="query.loginName" style="width:100px" placeholder="登录名称" class="handle-input mr10"></el-input> 
                <el-input v-model.trim="query.pid" style="width:100px" placeholder="上游ID" class="handle-input mr10"></el-input> 
               
                <el-input v-model.trim="query.phone" style="width:120px" placeholder="手机号" class="handle-input mr10"></el-input> 
                <!--<el-input v-model.trim="query.memNum" type="number" oninput ="value=value.replace(/[^\d]/g,'')" style="width:135px;" placeholder="代理数量" class="handle-input mr10"></el-input> 
                <el-tooltip :content="query.mdes==1?'小于筛选':'大于筛选'" placement="top" style="margin-left:-75px;" >
                    <el-switch  class="tableScopeSwitch" 
                        v-model.trim="query.mdes"
                        active-color=""
                        inactive-color=""
                        active-value="1"
                        inactive-value="0"
                        active-text="小于"
                        inactive-text="大于">
                    </el-switch>
                </el-tooltip> -->
                  
                  </span>  
                    <el-button type="success" style="margin-left:10px" icon="el-icon-search"  @click="handleSearch"> 搜 索 </el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch"> 重 置 </el-button>
                <span class="closrSearchBtn" @click="changeI"  style="margin-left:30px;font-size:25px;line-height:35px;"><i :class="Ishow"></i></span>
                <el-button  type="primary" class="handle-del"  @click="changeOper" >角色变更</el-button> 
                
                </p>
            </div>
            <el-table :data="tableData"  class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="50" align="left"></el-table-column>
                <el-table-column prop="id" min-width="65" align="left" label="代理ID"></el-table-column>
                <el-table-column prop="pid" min-width="65" align="left" label="上游ID"></el-table-column>
                <el-table-column prop="loginName" min-width="100" align="left" label="账户名"></el-table-column>
                <el-table-column prop="rname" min-width="100" align="left" label="角色名称"></el-table-column>
                <el-table-column prop="fb1" min-width="100" align="center" label="绑定渠道">
                    <template slot-scope="scope">  
                        <i @click="treeShow(scope.row.id)" class='el-icon-edit'></i>
                    </template>
                </el-table-column>
                <el-table-column prop="num" min-width="100" align="left" label="渠道数量"></el-table-column> 
                <el-table-column prop="realName" min-width="70" align="left" label="姓名"></el-table-column>
                <el-table-column prop="phone" min-width="120" align="center" label="手机号"></el-table-column> 
                <el-table-column prop="shopCode" width="135" align="left" label="店铺编码"></el-table-column>  
                <el-table-column prop="createTime" min-width="180" align="center"  label="创建时间"> </el-table-column>     
            </el-table> 
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 50,500]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="更改手机号" :modal-append-to-body='false' :visible.sync="aesIdVisible" width="350px">
            <el-form ref="form" :model="form" label-width="90px"> 
                <el-form-item label="原来手机号" >
                    <span>{{form.phone}}</span>
                </el-form-item>
                <el-form-item label="修改手机号" >
                    <el-input  v-model.trim="formL.phone" style="width:160px" type="number" placeholder="请输入修改手机号" oninput ="value=value.replace(/[^\d]/g,'')"></el-input> 
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aesIdVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveAesId">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="更改账户名" :modal-append-to-body='false' :visible.sync="loginVisible" width="350px">
            <el-form ref="form" :model="form" label-width="90px"> 
                <el-form-item label="原来账户名" >
                    <span>{{form.loginName}}</span>
                </el-form-item>
                <el-form-item label="修改账户名" >
                    <el-input  v-model.trim="formL.loginName" style="width:160px"   placeholder="修改账户名"  ></el-input> 
                </el-form-item>
                <el-form-item label="修改密码" >
                    <el-input  v-model.trim="formL.loginPass" style="width:160px"   placeholder="修改密码"  ></el-input> 
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="loginVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveLoginName">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增代理" :modal-append-to-body='false' :visible.sync="addVisible"  center="true"  width="320px">
            <el-form ref="form1" :model="form" label-width="80px">
                <el-form-item label="账户名称" >
                    <el-input  type="text" placeholder="账户名称"  v-model.trim="form1.loginName"   style="width:200px;" ></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" >
                    <el-input  type="text" placeholder="真实姓名"  v-model.trim="form1.realName"   style="width:200px;" ></el-input>
                </el-form-item>
                <el-form-item label="代理等级" >
                    <el-select v-model.trim="form1.gid" @click="getGradeSelect" placeholder="代理等级" style="width:200px;" filterable clearable @clear="resetSelect" class="handle-select mr10"> 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.gname" :value="item.id" />    
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input type="number" v-model.trim="form1.phone"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="手机号" style="width:200px;"></el-input>
                </el-form-item>
                <!--<el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form1.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled" style="margin-left:10px;width:90px;" :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item>-->
                <el-form-item label="初始密码">
                    <el-input v-model.trim="form1.loginPass"  placeholder="登录账号" style="width:200px;"></el-input>
                </el-form-item>
                 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 变更代理弹出框 -->
        <el-dialog :close-on-click-modal="false" title="代理转移" :modal-append-to-body='false' :visible.sync="exchangeVisible"   width="380px">
            <el-form ref="form" :model="form2" label-width="70px">
                <el-form-item label="代理账户" >
                    <span>{{form2.names}}</span>
                </el-form-item>
                <el-form-item label="转移至" >
                    <el-select v-model.trim="form2.shopCode" placeholder="店铺编码"   filterable clearable  @change="getSelect1"  > 
                        <el-option v-for="item in select2.option" :key="item.id" :label="item.optKey" :value="item.optKey" />  
                    </el-select>
                </el-form-item> 
                <el-form-item label="变更等级" >
                    <el-select v-model.trim="form2.gid" placeholder="代理等级"  filterable clearable   > 
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>
                </el-form-item>
                <el-input style="display:none" v-model="form.ids"></el-input> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exchangeVisible =false">取 消</el-button>
                <el-button type="primary" @click="exchangeMember">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 变更代理弹出框 -->
        <el-dialog :close-on-click-modal="false" title="更改分销权限" :modal-append-to-body='false' :visible.sync="operVisible"  center="true" width="270px">
            <el-form ref="form" :model="form2"  >  
                    <el-radio-group v-model.trim="form2.rid"> 
                        <el-radio-button label="1">超级管理员</el-radio-button> 
                        <el-radio-button label="2">普通管理员</el-radio-button> 
                        <el-radio-button label="3">上架分销权</el-radio-button>
                        <el-radio-button label="4">无限分销权</el-radio-button> 
                        <el-radio-button label="5">二级分销权</el-radio-button> 
                        <el-radio-button label="6">一级分销权</el-radio-button>
                        <el-radio-button label="7">无分销权</el-radio-button>   
                    </el-radio-group> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="operVisible=false">取 消</el-button>
                <el-button type="primary" @click="saveOper">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 变更代理弹出框 -->
        <el-dialog :close-on-click-modal="false" title="角色变更" :modal-append-to-body='false' :visible.sync="operRidVisible"   width="450px">
            <el-form ref="form" :model="form3" label-width="70px">   
                <el-form-item label="代理账户" >
                    <span>{{form3.names}}</span>
                </el-form-item> 
                <el-form-item label="角色变更" >
                    <el-select v-model="form3.rcode"  placeholder="选择角色" filterable  clearable  @clear="resetSelect" >
                    <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>  
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="operRidVisible=false">取 消</el-button>
                <el-button type="primary" @click="saveRidOper">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="绑定渠道" :modal-append-to-body='false' :visible.sync="treeVisible" top="50px" width="400px">
             <div class="over">
                <el-tree
                    class="tree"  
                    ref="tree"
                    :data="treeData"  
                    show-checkbox
                    node-key="id"
                    default-expand-all
                    :default-checked-keys="checkData"  
                    :props="defaultProps"
                    highlight-current
                    draggable = "false" 
                ></el-tree>
            </div> 
            <span slot="footer" class="dialog-footer" >
                <el-button @click="treeVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBind">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {fetchData,changeForm,changeRole,getTreeData,getCheckData,saveBind} from '../../api/operChannel';
import {getSelect} from '../../api/operRole';
export default {

    data() {
        return {  
            Ishow:'el-icon-caret-bottom',
            closeSearch:'',
            Timeout:'',
            mid:'',
            secret:'',
            stationId:'', 
            theight:'550px',
            theight2:'550px',
            loginName:'',
            avatar:'',
            treeData:[],
            showData:[],
            checkData:[],
            dataSize:'',
            loading:false,
            aesIdVisible:false,
            operVisible:false,
            editVisible: false,
            loginVisible:false,
            addVisible:false,
            treeVisible:false,
            exchangeVisible:false,
            operRidVisible:false,
            select:{ option:'',  },
            select1:{ option:'',  },
            select2:{option:''},
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
            }, 
            query: { 
                pageIndex: 1,
                pageSize: 10, 
                mtype:'0',
                odes:'0', 
                mdes:'0',
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            
            pageTotal: 0,
            form2: {  
                shopCode:'',
                ids:'',
                names:'',
            },
            form: {   
                ids:'',
                names:'',
            },
            formL:{phone:'',loginName:''},
            form1: {  loginPass:'123456'
            },
            form2: {  
            },
            form3: {  
            },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted: function () {
        if(document.body.clientWidth<1000){
            this.closeSearch=true;
        }else{
            this.closeSearch=false; 
        };
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.loginName = localStorage.getItem('ms_username'); 
        this.avatar = localStorage.getItem('ms_stationLogo');  
        //查询列表 
        this.query.stationId = this.stationId; 
        this.query.mid = this.mid; 
        this.query.secret = this.secret; 
        this.getData(); 
         //获取下拉框数据
        this.getSelect1();   
    },

    methods: { 
        treeShow(rcode){   
            this.rcode = rcode;
            this.getTreeData(rcode);  
            this.getCheckData(rcode); 
            this.treeVisible = true;
        },
        treeRefresh(rcode){    
            this.getTreeData(rcode);  
            this.getCheckData(rcode);  
        },
        getTreeData(rcode){
            let data = {};
            data.stationId = this.stationId;  
            data.rcode = rcode;
            getTreeData(data).then(res => {   
                if(res.code=='200'){ 
                    this.treeData = res.data.result; 
                    this.dataSize = res.data.size;
                }
            });
        }, 
        getCheckData(rcode){
            let data = {};
            data.stationId = this.stationId;  
            data.uid = rcode;
            getCheckData(data).then(res => {   
                if(res.code=='200'){  
                    this.checkData = res.data; 
                }
            });
        }, 
        // 保存更改
        saveBind(){
            var checkedNodes = this.$refs.tree.getCheckedNodes(true);
            var itemIds = "";
            var itemArray = [];
            
            checkedNodes.forEach(nodes => {
                if(nodes.pid==0){
                    itemArray.push(nodes.id); 
                } 
            })
            
            // 利用set没有重复的值这一特性, 实现数组去重。Array.form方法可以将 Set 结构转为数组。
            itemArray = Array.from(new Set(itemArray)) ;
            for(var i=0;i<itemArray.length;i++){ 
                itemIds+=itemArray[i]+",";
            }
            if(itemIds.length>0){
                itemIds = itemIds.substr(0,itemIds.length-1);
            }
            if(checkedNodes.length == this.dataSize){
                itemIds = "0,"+itemIds;
            } 
            let data = {};
            data.channelCodes = itemIds;
            data.uid = this.rcode; 
            data.stationId = this.stationId;
            saveBind(data).then(res => {
                if(res.code=='200'){ 
                    this.getData(); 
                    this.$message.success(res.message);  
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },


        changeI(){  
                if(this.Ishow == 'el-icon-caret-bottom'){ 
                    this.Ishow = 'el-icon-caret-top';
                    this.closeSearch=false;
                }else{
                    this.Ishow='el-icon-caret-bottom'; 
                     this.closeSearch=true;
                }
            },   
         //获取下拉框数据
        getSelect1(){ 
            this.select1.option = '';
            this.select1.mid = this.mid;
            this.select1.stationId = this.stationId;
            this.select1.shopCode = this.form2.shopCode; 
            getSelect(this.select1).then(res => {  
                if(res.code=='200'){ 
                    this.select1.option = res.data; 
                }
            });
        },  
        copyLink(text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success("店铺编码复制成功"); 
           
        },
        //排序弹窗开启
        AesIdEdit(index,row){
            this.form = row; 
            this.aesIdVisible = true;
        },
        //排序弹窗开启
        loginNameEdit(index,row){
            this.form = row; 
            this.loginVisible = true;
        },
        editOper(row){
            this.form2 = row;
            this.operVisible = true;
        },  
        //更改分销权
        saveOper(){
            let data = {};
            data.id = this.form2.id;
            data.rid = this.form2.rid;
            data.stationId = this.stationId;
            data.mid = this.mid; 
            updateSave(data).then(res => {
                if(res.code=='200'){
                    this.operVisible = false;
                    this.$message.success("变更成功"); 
                    this.getData();
                }else{ 
                    this.$message.error("变更失败"); 
                } 
            });
        },
         
        //排序保存
        saveAesId(){
            let data = {};
            data.stationId = this.stationId;
            data.mid = this.mid;
            data.id = this.form.id;
            data.phone = this.formL.phone;
            updateSave(data).then(res => {
                if(res.code=='200'){ 
                    this.aesIdVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
        },
        //排序保存
        saveLoginName(){
            let data = {};
            data.stationId = this.stationId;
            data.mid = this.mid;
            data.id = this.form.id;
            data.loginName = this.formL.loginName;
            data.loginPass = this.formL.loginPass;
            updateSave(data).then(res => {
                if(res.code=='200'){ 
                    this.loginVisible = false;
                    this.$message.success("修改成功"); 
                    this.getData();
                }else{ 
                    this.$message.error("修改失败"); 
                } 
            });
        },
 
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            this.theight = '540px'; 
            columns.forEach((column, index) => {
            if (index === 1) {//只找第一列放合计
                sums[index] = '统计';
                return;
            } 
            if(index < 10 ){
               sums[index] = '';
               return;
            } 
            const values = data.map(item => Number(item[column.property]));//把对应一列中的之全部取出，放到一个数组中
            if (!values.every(value => isNaN(value))) {//如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
                sums[index] = values.reduce((prev, curr) => {
                console.log(prev, curr);
                const value = Number(curr);//将values中的每个值转换为number类型
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
                }, 0);  
                if(index == 12){ 
                    sums[index] = parseFloat(sums[index]).toFixed(2); 
                    sums[index] += '元';
                }
            } else {
                sums[index] = ''
            }
            });
            window.setTimeout(() => { 
                this.theight = this.theight2; 
            }, 500) ;
            return sums; 
        },
        // 触发搜索按钮

        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'shopCode'); 
            this.$set(this.query, 'phone'); 
            this.$set(this.query, 'realName');  
            this.$set(this.query, 'loginName');  
            this.$set(this.query, 'id'); 
            this.$set(this.query, 'pid'); 
            this.$set(this.query, 'rcode');   
            this.getData();
        }, 

       

         //刷新
        refresh(){
            history.go(0); 
        },

        //查询
        getData(){
            // 获取列表数据  
            fetchData(this.query).then(res => {   
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;   
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0; 
                } 
                
            });
        },

        //发送验证码
        sendCode(){ 
            //正则匹配手机号
            const phone = this.form1.phone;
            const reg =/^[1][3-9][0-9]{9}$/;
            if(!reg.test(phone)){
                this.$message.error("请输入正确的手机号"); 
                return;
            }  
            //发送短信按钮倒计时提示  
            var that = this;
            var times = 59;
            this.sendSms.disabled = true;
            this.sendSms.type='info';
            this.sendSms.color ="color:#333";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = this.mid;
            this.sendSms.stationId = this.stationId; 
            this.sendSms.loginName = this.loginName; 
            this.sendSms.phone = phone;   
            this.sendSms.code = "-1";
            sendSmsCode(this.sendSms).then(res => {
                if(res.code=='200'){ 
                    this.sendSms.code = res.data.code;
                    this.$message.success('发送成功'); 
                    this.getData();
                }else{ 
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                } 
            }); 
        },
        // 删除
        handDelete(index, row) {  
            this.form.gid=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.addVisible = false;
                        this.$message.success('删除成功'); 
                        this.query.pageIndex = this.query.pageIndex-1;
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.success(res.message); 
                    } 
                });
            }) 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        //更改角色
        changeOper() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要变更角色的用户");
                return;
            } 
            let ids = '';
            let names = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ',';
                names += this.multipleSelection[i].realName + '，';
            } 
            this.form3.ids = ids.substr(0,ids.length-1);
            this.form3.names = names.substr(0,names.length-1);  
            this.operRidVisible = true;
        },
        //批量更改分销权
        saveRidOper(){
            let data = {};
            data.ids = this.form3.ids;
            data.rid = this.form3.rcode;
            data.stationId = this.stationId;
            data.mid = this.mid; 
            changeRole(data).then(res => {
                if(res.code=='200'){
                    this.operRidVisible = false;
                    this.$message.success("变更成功"); 
                    this.getData();
                }else{ 
                    this.$message.error("变更失败"); 
                } 
            });
        },
        handleStatus(index,row){   
            let data = {};
            data.status = row.status;
            data.id = row.id;
            data.stationId = this.stationId; 
            handleStatus(data).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                }  
            }); 
        },
        changeGrade() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要转移的代理");
                return;
            }
            this.getSelect2(); 
            let ids = '';
            let names = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ',';
                names += this.multipleSelection[i].realName + '，';
            } 
            this.form2.ids = ids.substr(0,ids.length-1);
            this.form2.names = names.substr(0,names.length-1);  
            this.exchangeVisible = true;
        },
        //代理转移
        exchangeMember(){
            let data = {};
            data.shopCode = this.form2.shopCode;
            data.ids = this.form2.ids;
            data.gid = this.form2.gid;
            data.stationId = this.stationId; 
            exchangeMember(data).then(res => {
                if(res.code=='200'){
                    this.exchangeVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
        },
        //取消更改等级
        changeFalse(){
            this.editVisible = false;
            //清空多选值
            this.multipleSelection = [];
            //多选框反选
            this.$refs.multipleTable.clearSelection();
        },

        // 新增代理
        addBind() {
            this.getGradeSelect(); 
            this.addVisible = true;
        },
        //保存新增
        saveForm() {  
            this.form1.mid = this.mid;
            this.form1.stationId = this.stationId; 
            if( !this.form1.loginName ){
                this.$message.error("请填写登录名称");
                return;
            }
            if( !this.form1.realName ){
                this.$message.error("请填写真实姓名");
                return;
            }
            if( !this.form1.gid ){
                this.$message.error("请选择代理等级");
                return;
            } 
            if( !this.form1.phone  ){
                this.$message.error("请填写手机号");
                return;
            }
           /* if( !this.form1.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form1.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            } */
            if( !this.form1.loginPass){
                this.$message.error("请输入初始密码");
                return;
            }  
            this.addVisible = false;
            this.loading = true;
            this.form1.avatar = this.avatar;
            saveForm(this.form1).then(res => {
                this.loading = false;
                if(res.code=='200'){
                    
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
        
        // 保存更改
        saveEdit() { 
            if( !this.form.gid){
                this.$message.error("请选中要变更的等级");
                return;
            }  
            this.form.mid = this.mid;
            this.form.stationId = this.stationId;  
            changeForm(this.form).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>  
<style>
.tableScopeSwitch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
}
/*打开时文字位置设置*/
.tableScopeSwitch .el-switch__label--right {
    z-index: 1;
    right: -10px;    /*不同场景下可能不同，自行调整*/
}
/*关闭时文字位置设置*/
.tableScopeSwitch .el-switch__label--left {
    z-index: 1;
    left: 20px;    /*不同场景下可能不同，自行调整*/
}
/*显示文字*/
.tableScopeSwitch .el-switch__label.is-active {
    display: block;
}
.tableScopeSwitch.el-switch .el-switch__core,
.el-switch .el-switch__label {
    width: 60px !important;    /*开关按钮的宽度大小*/
} 

.el-radio-button--small .el-radio-button__inner{
    font-size:15px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}


.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
@media screen and (min-width:999px){ 
    .mr10 {
        margin-right: 10px;
    }
}
</style>
